import { ThirdPartyLogisticsApiClient } from '@fourthwall/services/dist/ThirdPartyLogisticsApiClient'
import { createQueryHook } from '@fourthwall/utils'

export const useInventoryShipmentsQuery = createQueryHook(
  ThirdPartyLogisticsApiClient.getInventoryShipments,
  {
    queryKey: ['inventoryShipments'],
  },
)

export type InventoryShipmentResponse = Awaited<
  ReturnType<typeof ThirdPartyLogisticsApiClient.getInventoryShipments>
>['data']
